import { UserRewardsStatsResponse } from '../../types/rewards';

export const getUserRewardsStatsModel = (response: UserRewardsStatsResponse): UserRewardsStatsResponse => response;
